import { render, staticRenderFns } from "./LoanManage.vue?vue&type=template&id=3fd196a8&scoped=true&"
import script from "./LoanManage.vue?vue&type=script&lang=js&"
export * from "./LoanManage.vue?vue&type=script&lang=js&"
import style0 from "./LoanManage.vue?vue&type=style&index=0&id=3fd196a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd196a8",
  null
  
)

export default component.exports